import { Flex, Text } from '@radix-ui/themes';
import { TbArrowUpRight, TbUser } from 'react-icons/tb';
import { Avatar as AvatarComponent } from '@radix-ui/themes';
import { capitalise } from '~/utils/capitalise';
import { useSession } from '~/features/auth/context/Session';
import { useStore } from '@nanostores/react';
import { projectStore } from '~/stores/project';
import Styles from './avatar.module.scss';

export function Avatar({
  handleNavigationToAccount,
}: {
  handleNavigationToAccount?: (route: string, search?: Record<string, unknown>) => void;
}) {
  const { session } = useSession();
  const project = useStore(projectStore.project);
  const initial = session?.identity?.traits.given_name
    ?.split(' ')
    .map((n: string) => n[0])
    .join('');
  const picture = session?.identity?.traits.picture;

  return (
    <Flex align="center" gap="3" mb="1">
      <Flex>
        {picture ? (
          <AvatarComponent radius="large" size="3" fallback={capitalise(initial)} src={picture} />
        ) : (
          <Flex className={Styles.FallbackAvatar} justify="center" align="center">
            <TbUser color="var(--gray-12)" fontSize="2rem" />
          </Flex>
        )}
      </Flex>
      <Flex direction="column">
        {session?.identity?.traits.nickname ? (
          <Text size="2" weight="bold">
            {session?.identity?.traits.nickname}
          </Text>
        ) : session?.identity?.traits.given_name && session?.identity?.traits.family_name ? (
          <Text size="2" weight="bold">
            {session?.identity?.traits.given_name} {session?.identity?.traits.family_name}
          </Text>
        ) : (
          <Text size="2" weight="bold">
            {session?.identity?.traits.email}
          </Text>
        )}
        <Flex
          align="center"
          gap="1"
          role="button"
          tabIndex={0}
          className={Styles.Link}
          onKeyUp={(e) => {
            if (e.key === 'Enter') {
              handleNavigationToAccount?.(
                '/account',
                project?.id ? { backToProjectId: project.id, content: 'profile' } : { content: 'profile' }
              );
            }
          }}
          onClick={() => {
            handleNavigationToAccount?.(
              '/account',
              project?.id ? { backToProjectId: project.id, content: 'profile' } : { content: 'profile' }
            );
          }}
        >
          <Text size="2" weight="regular">
            View account
          </Text>
          <TbArrowUpRight fontSize="1.2rem" style={{ transform: 'translateY(1px)' }} />
        </Flex>
      </Flex>
    </Flex>
  );
}
